// extracted by mini-css-extract-plugin
export var btn = "liteBanner-module--btn--LBRUQ";
export var card = "liteBanner-module--card--kmVXQ";
export var container = "liteBanner-module--container--woDkr";
export var download = "liteBanner-module--download--GG-rF";
export var headDescr = "liteBanner-module--headDescr--q3YCJ";
export var headTitle = "liteBanner-module--headTitle--PH+-6";
export var img = "liteBanner-module--img--v6g7k";
export var subscription = "liteBanner-module--subscription--rfURK";